export const platformAdminDashboard = {
  title: "平台概览",
  subtitle: "统一查看平台概览与治理入口。",
  summaryOverall: "平台状态：{value}",
  summaryOnline: "在线组件：{count}",
  summaryChecks: "检查总数：{count}",
  summaryIdentityPhase: "身份阶段：{value}",
  summaryAssetPhase: "资产阶段：{value}",
  summaryExecutionPhase: "执行阶段：{value}",
  summaryIdentityRemediation: "身份整改：{count}",
  summaryAssetRemediation: "资产整改：{count}",
  kpiOverall: "平台状态",
  kpiOnline: "在线组件",
  kpiChecks: "检查总数",
  kpiIdentityRemediation: "身份整改",
  kpiAssetRemediation: "资产整改",
  governanceTitle: "治理概览",
  messages: {
    loadFailed: "加载平台概览失败",
  },
  identityGovernanceTitle: "身份治理概览",
  assetGovernanceTitle: "资产治理概览",
  governanceWarnings: "预警项",
  governanceCritical: "严重项",
  governanceIssueActiveCredentials: "补发有效凭据",
  governanceConfigureAccessGrants: "补配置授权规则",
  governanceConfigureRoleMappings: "补配置角色映射",
  governanceObjectSpaceItems: "对象空间整改",
  governanceReferenceItems: "引用整改",
  governanceConfigureSpaceGrants: "补配置空间授权",
  governanceEnableSpaceGovernance: "纳入对象空间治理",
  governanceNormalizeReferenceScope: "规范引用作用域",
  openIdentity: "打开身份治理",
  openAssets: "打开资产治理",
  openCenters: "打开平台入口与中心",
  openOpsCenter: "打开运维中心",
  opsCenterNotice: "首页只展示平台概览与入口汇总；运行接入状态真相请前往运维中心查看。",
  applicationsTitle: "业务入口",
  centersTitle: "平台入口与中心",
  openConsole: "打开控制台",
} as const;
